export const CURRENT_LOCALE = 'registration_lang' as const;